export default {
  breakpoints: {
    sm: '0px',
    md: '768px',
    lg: '996px',
  },
}
